import {Component} from 'react'
import Check from 'react-feather/dist/icons/check.js'
import PropTypes from 'prop-types'

import UploadDropZone from '../../Form/Field/UploadDropZone.jsx'
import conf from '../../../conf.js'
import upload from './submit.js'

import Loader from '../../../../shared/components/Loader/Loader.jsx'
import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx'
import Popup from "../../Popup/Popup.jsx"

import './UploadUserImageForm.scss'

class UploadUserImageForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      uploading: false,
      errors: null,
      popup: false,
      image: props.image
    }
  }

  static propTypes = {
    userId: PropTypes.number.isRequired,
    image: PropTypes.object,
    onUploadSuccess: PropTypes.func,
    onSubmitSuccess: PropTypes.func,
    className: PropTypes.string,
    title: PropTypes.string,
    hideText: PropTypes.bool
  }

  static defaultProps = {
    className: '',
    image: null,
    onUploadSuccess: () => {},
    onSubmitSuccess: () => {},
    hideText: false
  }

  componentDidUpdate(prevProps) {
    if (prevProps.image !== this.props.image) {
      this.setState({ image: this.props.image })
    }
  }

  sleep = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms))
  }

  onSubmit = async (data) => {
    this.setState({ uploading: true, errors: null })

    try {
      const uploadResult = await upload({ user: this.props.userId }, { body: data })
      this.props.onUploadSuccess(uploadResult.data)

      this.setState({
        image: uploadResult.data,
        popup: true,
        uploading: false
      })

      await this.sleep(1500)
      this.props.onSubmitSuccess()
      return uploadResult.data
    } catch (e) {
      console.warn(e)
      this.setState({ errors: e.errors })
    } finally {
      this.setState({ uploading: false, popup: false })
    }
  }

  render() {
    const { title, className, hideText } = this.props
    const { image, uploading, popup, errors } = this.state

    return (
      <div className={className}>
        <FormGlobalErrors errors={errors} />
        <UploadDropZone
          className="image-dropzone"
          input={{ value: image, name: 'uploadedImage' }}
          hideText={hideText}
          dropText="Déposer ma photo de profil en Drag'n'Drop"
          uploadText="Sélectionner ma photo"
          uploadModifyText="Modifier ma photo"
          onSubmit={this.onSubmit}
          maxSize={conf.server.uploadMaxSize}
          acceptText=".jpg, .gif, .png"
          accept={conf.allowedMimeTypes.userImage}
        >
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {title && <h4>{title}</h4>}
            {image && (
              <div className="image-preview">
                <img src={image.square} alt="Profil" />
              </div>
            )}
          </div>
        </UploadDropZone>

        <Loader visible={uploading}>Upload en cours...</Loader>

        <Popup visible={popup}>
          <Check size={50} />
          <br />
          Image uploadée
        </Popup>
      </div>
    )
  }
}

export default UploadUserImageForm